module.exports = __webpack_public_path__ + "static/media/LeiZhang.51ce831e.jpeg";